import { render, staticRenderFns } from "./VideoShowComp.vue?vue&type=template&id=64e6cd9a&scoped=true&"
import script from "./VideoShowComp.vue?vue&type=script&lang=js&"
export * from "./VideoShowComp.vue?vue&type=script&lang=js&"
import style0 from "./VideoShowComp.vue?vue&type=style&index=0&id=64e6cd9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e6cd9a",
  null
  
)

export default component.exports